import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { ThumbsUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Carousel } from 'components/Carousel';
import { ContentCard } from 'components/ContentCard';
import { type Wellbeing } from 'types/wellbeing';

interface SuggestedContentProps {
  suggestedList: Wellbeing[];
}

export const SuggestedContent = ({ suggestedList }: SuggestedContentProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.SERVICES);

  return (
    <section className="w-full min-w-0 overflow-x-visible">
      <Carousel
        header={
          <div className="flex items-center gap-2">
            <ThumbsUp className="size-8 shrink-0 text-denim-800" />
            <h3 className="text-base font-medium leading-5 text-denim-800 am-3xl:text-lg am-3xl:leading-6">
              {t('Pae.Suggested.heading')}
            </h3>
          </div>
        }
        items={suggestedList.map(item => (
          <ContentCard key={item.id} {...item} showCategoryIcon />
        ))}
      />
    </section>
  );
};
